import { useMemo } from 'react'
import { TechnologiesModule } from '@core/modules/digital-footprint/technologies/technologies.module'
import { buildOpenIssuesByTechnologyName } from '@core/modules/digital-footprint/technologies/technologies.filters'
import { countIssuesBySeverity } from '@routes/digital-footprint/routes/assets/components/assetsTable/utils'
import { useAllIssues } from '@/ui/routes/issues/hooks/useAllIssues'

export const useTechnologiesWithIssues = () => {
    const { data } = TechnologiesModule.useStore()
    const { data: allIssues } = useAllIssues()

    const openIssuesByName = useMemo(
        () => buildOpenIssuesByTechnologyName(allIssues),
        [allIssues]
    )

    const issueCountsByName = useMemo(() => {
        const map: Record<string, ReturnType<typeof countIssuesBySeverity>> = {}
        Object.keys(openIssuesByName).forEach((name) => {
            map[name] = countIssuesBySeverity(openIssuesByName[name])
        })
        return map
    }, [openIssuesByName])

    const technologiesWithIssues = useMemo(() => {
        const uniqueTechnologies = [
            ...new Map(data.map((item) => [item.id, item])).values(),
        ]

        return uniqueTechnologies.map((technology) => ({
            ...technology,
            issues: (openIssuesByName[technology.name] ??
                []) as TTechnology['issues'],
        }))
    }, [data, openIssuesByName])

    return {
        technologiesWithIssues,
        openIssuesByName,
        issueCountsByName,
    }
}
